import { createAsyncThunk } from '@reduxjs/toolkit';
import type { RootState } from 'store/store';
import type { QuizAnswerPayload, QuizQuestion } from 'features/quizzes/types';
import { submitQuizQuestionService } from 'features/quizzes/services';

interface SubmitQuestionResponse {
  id: string;
  questionId: string;
  choices: number[];
  nextQuestion: QuizQuestion;
}

export const submitQuizQuestion = createAsyncThunk<
  SubmitQuestionResponse,
  QuizAnswerPayload,
  {
    state: RootState;
  }
>('quizzes/submitQuizQuestion', submitQuizQuestionService);
